import React from 'react';
import mainBG from '../../../assets/EinführungMainBG.png';
import ellipseBG from '../../../assets/EllipseBG.png';
import { useTranslation } from "react-i18next";

const JaAccept = ({ nextClick, backClick, formik }) => {
    const { t } = useTranslation();

    return (
        <div style={{ background: `url(${mainBG})` }} className="h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between">
            <div></div>
            <div style={{ background: `url(${ellipseBG})` }} className="min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative">
                <div className="relative pt-20 w-full max-w-[36rem] mx-auto flex flex-col justify-between h-full text-center pb-4 px-6 sm:px-0">
                    {/* Content */}
                    <div>
                        <h1 className="text-white text-xl font-bold">{t(`s-12-title`)}</h1>
                        <p className="text-white text-base italic mt-12">
                            {t(`s-12-desc`)}  
                            <a target="_blank" rel="noopener noreferrer" className="underline mx-1" href={t(`drive_link_4`)}>
                                {t(`s-accept-link`)}
                            </a> 
                            {t(`s-accept-des`)}
                        </p>

                        {/* Checkbox */}
                        <div className="max-w-[32rem] mx-auto mt-6">
                            <div className="flex items-start gap-3">
                                <input
                                    type="checkbox"
                                    id="policy"
                                    name="termsAndCondition"
                                    checked={formik.values.termsAndCondition}
                                    onChange={formik.handleChange}
                                    className="radio-circle !w-[20px] !h-[20px]"
                                />
                                <label htmlFor="policy" className="text-white text-left text-base font-semibold">
                                    {t(`s-12-check`)}
                                </label>
                            </div>
                            {formik.errors.termsAndCondition && (
                                <div className="text-red-500 text-sm text-left mt-1">{formik.errors.termsAndCondition}</div>
                            )}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="w-full max-w-[32rem] flex gap-6 flex-col-reverse sm:flex-row pt-6">
                        <button className="w-full button_primary" onClick={backClick}>
                            {t(`s-2-btn1`)}
                        </button>
                        <button className="w-full button_secodry" onClick={nextClick}>
                            {t(`s-2-btn2`)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default JaAccept;
